type WishlistHeaderProps = {
  isPending: boolean;
  totalItems: number;
};

export function WishlistHeader({ isPending, totalItems }: WishlistHeaderProps) {
  return (
    <header className="camp-fade-up text-left">
      {/* <p className="m-0 text-[11px] font-semibold tracking-[0.12em] text-[var(--dash-brand)] uppercase">
        Saved
      </p> */}
      <h1 className="m-0 mt-1 text-2xl font-semibold tracking-tight text-[var(--dash-ink)]">
        My Wishlist
      </h1>
      <p className="mt-1 mb-0 text-sm text-[var(--dash-muted)]">
        {isPending
          ? 'Loading wishlist…'
          : totalItems > 0
            ? `${totalItems} saved screen${totalItems === 1 ? '' : 's'}`
            : 'Screens you save appear here'}
      </p>
    </header>
  );
}
